import { render, staticRenderFns } from "./doubt.vue?vue&type=template&id=909c91ba&scoped=true"
import script from "./doubt.vue?vue&type=script&lang=js"
export * from "./doubt.vue?vue&type=script&lang=js"
import style0 from "./doubt.vue?vue&type=style&index=0&id=909c91ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909c91ba",
  null
  
)

export default component.exports